import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full h-1 dark:bg-nucleus-darkBlue shadow-md relative -top-1", _ctx.checkAccessPage(_ctx.currentRouteName) ? 'bg-black' : 'bg-white'])
  }, null, 2))
}